import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxUserpilotService } from './userpilot.service';

export const ngxUserpilotServiceModule = angular.module('ngxUserpilotServiceModule', [])
	.factory('userpilotService', downgradeInjectable(NgxUserpilotService))
	.name;
